import { Grid, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react";

const CuentaRegresiva = () => {
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const fechaCongreso = new Date(2023, 7, 11, 8, 0, 0);

            let actual = new Date();
            const now = new Date(actual.setMonth(actual.getMonth() + 1));

            var timeleft = fechaCongreso - now;

            var d = Math.floor(timeleft / (1000 * 60 * 60 * 24));
            var h = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var m = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
            var s = Math.floor((timeleft % (1000 * 60)) / 1000);

            setDays(d < 10 ? `0${d}` : d)
            setHours(h < 10 ? `0${h}` : h)
            setMinutes(m < 10 ? `0${m}` : m)
            setSeconds(s < 10 ? `0${s}` : s)
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [days, hours]);


    return (
        <Grid
            container
            spacing={1}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
                padding: 2,
                color: "rgb(18,161,154)",
            }}
        >
            <Grid item sx={{ textAlign: "center", }}>
                <Typography variant="h4" className="poppins">Cuenta regresiva</Typography>
            </Grid>
            <Grid item>
                <Grid container spacing={1} sx={{ flexFlow: 'nowrap'}}>
                    <Grid item>
                        <Stack flexDirection="column" alignItems="center">
                            <Typography variant="h4" className="freestyle">{days}</Typography>
                            <Typography variant="h4" className="freestyle">dias</Typography>
                        </Stack>
                    </Grid>
                    <Grid item>
                        <Typography variant="h4" className="freestyle">:</Typography>
                    </Grid>
                    <Grid item>
                        <Stack flexDirection="column" alignItems="center">
                            <Typography variant="h4" className="freestyle">{hours}</Typography>
                            <Typography variant="h4" className="freestyle">horas</Typography>
                        </Stack>
                    </Grid>
                    <Grid item>
                        <Typography variant="h4" className="freestyle" >:</Typography>
                    </Grid>
                    <Grid item>
                        <Stack flexDirection="column" alignItems="center">
                            <Typography variant="h4" className="freestyle">{minutes}</Typography>
                            <Typography variant="h4" className="freestyle">minutos</Typography>
                        </Stack>
                    </Grid>
                    <Grid item>
                        <Typography variant="h4" className="freestyle">:</Typography>
                    </Grid>
                    <Grid item>
                        <Stack flexDirection="column" alignItems="center">
                            <Typography variant="h4" className="freestyle">{seconds}</Typography>
                            <Typography variant="h4" className="freestyle">segundos</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CuentaRegresiva